<template>
    <section class="dashboard">
        <div class="panel" 
        v-if="localStorage.roles.includes('OnlineDirector') 
        || localStorage.roles.includes('OnlineReelReviewer')
        || localStorage.roles.includes('CampusDirector') && terms">
            <div class="panel-heading">
                <h2 @click="showPanel==='finalProjects'?showPanel=null:showPanel='finalProjects'">Final Projects
                    <i class="fa fa-caret-down" v-if="showPanel==='finalProjects'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>
            <div class="panel-body nopad" v-show="showPanel==='finalProjects'">
                <final-projects></final-projects>
            </div>
        </div>
        <div class="panel" v-if="localStorage.roles.includes('OnlineDirector') && allGroups && terms && academicPaths && supervisors">
            <div class="panel-heading">
                <h2  @click="showPanel==='statistics'?showPanel=null:showPanel='statistics'">
                    Group Statistics
                    <i class="fa fa-caret-down" v-if="showPanel==='statistics'"></i>
                    <i v-else class="fa fa-caret-right"></i>
            </h2>
            </div>
            <div class="panel-body row" v-show="showPanel==='statistics'">
                <div class="col-xs-12">
                    <div class="form-group">
                        <select v-model="selectedGroup" class="form-control">
                            <option v-if="group.students.length > 0 && group.groupTerm.type === 'foundation'" v-for="group in allGroups" :value="group">
                                {{termName(group.groupTerm.id)}} &mdash; Group {{group.label}} &mdash; {{supervisorName(group.id)}}
                            </option>
                            <option v-if="group.students.length > 0 && group.groupTerm.type !== 'foundation'" v-for="group in allGroups" :value="group">
                                {{pathName(group.students[0].path)}} &mdash; {{termName(group.groupTerm.id)}} &mdash; Group {{group.label}} &mdash; {{supervisorName(group.id)}}
                            </option>
                        </select>
                    </div>
                    <div v-if="selectedGroup">
                        <div class="text-center">
                            <router-link :to="{
                                name: 'groupStatistics',
                                params: {groupId: selectedGroup.id, groupLabel: selectedGroup.label, term: selectedGroup.groupTerm.id}
                                }">
                                <button class="btn btn-success">View group statistics for Group {{selectedGroup.label}}</button>
                            </router-link>
                        </div>
                        <div class="form-group">
                            <ul v-if="selectedGroup.students">
                                <li v-for="student in selectedGroup.students">
                                    <router-link :to="{ name: 'student', params: { studentId: student.populiId }, query: {userId: student.id, term: selectedGroup.groupTerm.id}}">
                                        {{student.firstName}} {{student.lastName}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="panel courses nopad" v-if="!localStorage.roles.includes('CampusDirector') && courses && academicTerms">
            <div class="panel-heading">
                <h2 @click="showPanel==='courseAdmin'?showPanel=null:showPanel='courseAdmin'">Course Admin
                    <i class="fa fa-caret-down" v-if="showPanel==='courseAdmin'"></i>
                    <i v-else class="fa fa-caret-right"></i></h2>
            </div>
            <div class="panel-body nopad" v-show="showPanel==='courseAdmin'">
              
                <my-lessons v-if="(localStorage.roles.includes('Faculty'))" :courses="courses"></my-lessons>
              
                <p class="description">Edit your courses below:</p>
                <div class="term" v-if="hasTerm(term.id)" v-for="term in academicTerms">
                    <div class="panel">
                        <div class="panel-heading">
                            <h2 @click="selectedTerm===term.id?selectedTerm=null:selectedTerm=term.id">
                                    {{getTermName(term.id)}}
                                    <i v-if="selectedTerm===term.id" class="fa fa-caret-down"></i>
                                    <i v-else class="fa fa-caret-right"></i>
                               
                            </h2>
                        </div>
                        <div class="panel-body" v-show="selectedTerm === term.id">
                            <ul class="instances" v-for="(instances, pathId) in term.courses">
                                <h3>{{getPathNameFromId(pathId)}}<label>Order</label></h3> 

                                <li v-for="instance in instances">
                                    <h4>
                                        <router-link :to="{ name: 'courseAdmin', params: { instanceId: instance.id, courseId: instance.course }, query: {term_name: getTermName(instance.term),path_name: getPathName(instance) || 'Foundation' }}">                          
                                            <img v-if="instance.associated.image" :src="instance.associated.image"> 
                                            <img v-else src="./../assets/img/feedback-thumb.jpg"> 
                                            {{instance.associated.name}}
                                            <!-- <a v-if="instance.complete == false" class="flag">!</a> -->
                                        </router-link>
                                        <div class="position-wrapper">
                                            <select class="form-control" v-model="instance.position" @change="updateInstance(instance, term.id)">
                                                <option v-for="i in 15" :value="i" :key="i">{{i}}</option>
                                            </select>
                                        </div>
                                    </h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel" v-if="(localStorage.roles.includes('OnlineDirector') || localStorage.roles.includes('Supervisor')) && groups">
            <div class="panel-heading">
                <h2 @click="showPanel==='students'?showPanel=null:showPanel='students'">Your Students
                    <i class="fa fa-caret-down" v-if="showPanel==='students'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>
            <div class="panel-body nopad" v-show="showPanel==='students'">
                <p class="description">View Your Students below:</p>
                <ul class="list-group nopad groups">
                    <li v-for="group in groups" class="list-group-item">
                        <router-link :to="{
                            name: 'groupStatistics',
                            params: {groupId: group.id, groupLabel: group.label, term: group.groupTerm.id}
                            }">
                            <h4>{{group.groupTerm.type | capitalize}} {{group.groupTerm.startDate | fullMonthAndYear}} | {{group.label}}</h4>
                        </router-link>
                        <ul class="list-group">
                            <li v-for="student in group.students" class="list-group-item">
                                <router-link :to="{ name: 'student', params: { studentId: student.populiId }, query: {userId: student.id, term: group.groupTerm.id}}">
                                    {{student.firstName}} {{student.lastName}}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="panel" v-if="roles.includes('Supervisor')">
            <div class="panel-heading">                
                <h2 @click="showPanel==='introVideos'?showPanel=null:showPanel='introVideos'">Weekly Intro Videos
                    <i class="fa fa-caret-down" v-if="showPanel==='introVideos'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>
            <intro-videos v-if="showPanel==='introVideos'"></intro-videos>
        </div>


        <div class="panel" v-if="roles.includes('Supervisor') && academicTerms">
            <div class="panel-heading">                
                <h2 @click="showPanel==='weeklyContent'?showPanel=null:showPanel='weeklyContent'">Weekly Content
                    <i class="fa fa-caret-down" v-if="showPanel==='weeklyContent'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>
            <supervisor-weekly-content :courses="courses" v-if="showPanel==='weeklyContent'"></supervisor-weekly-content>
        </div>
        
        <div class="panel" v-if="roles.includes('Supervisor') && academicTerms">
            <div class="panel-heading">                
                <h2 @click="showPanel==='journey'?showPanel=null:showPanel='journey'">Journey (Your Student’s Important Milestones)
                    <i class="fa fa-caret-down" v-if="showPanel==='journey'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>
            <supervisor-journey v-if="showPanel === 'journey'"></supervisor-journey>
        </div>


        <div class="panel" v-if="roles.includes('CourseAdmin') || roles.includes('OnlineDirector')">
            
            <div class="panel-heading">
                <h2 @click="showPanel==='watermarkedFiles'?showPanel=null:showPanel='watermarkedFiles'">Watermarked Assets
                    <i class="fa fa-caret-down" v-if="showPanel==='watermarkedFiles'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>

            <watermarked-files v-if="showPanel === 'watermarkedFiles'">
            </watermarked-files>

        </div>

        <div class="panel" v-if="roles.includes('OnlineDirector')">
            
            <div class="panel-heading">
                <h2 @click="showPanel==='allIntroVideos'?showPanel=null:showPanel='allIntroVideos'">Intro Videos (All)
                    <i class="fa fa-caret-down" v-if="showPanel==='allIntroVideos'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>

            <director-intro-videos v-if="showPanel === 'allIntroVideos'">
            </director-intro-videos>

        </div>

        <div class="panel" v-if="roles.includes('OnlineDirector')">
            
            <div class="panel-heading">
                <h2 @click="showPanel==='allMeetings'?showPanel=null:showPanel='allMeetings'">Zoom Meetings
                    <i class="fa fa-caret-down" v-if="showPanel==='allMeetings'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>

            <director-meetings v-if="showPanel === 'allMeetings'">
            </director-meetings>

        </div>
        <div class="panel" v-if="roles.includes('OnlineDirector')">
            
            <div class="panel-heading">
                <h2 @click="showPanel==='allFeedback'?showPanel=null:showPanel='allFeedback'">Assignment Feedback
                    <i class="fa fa-caret-down" v-if="showPanel==='allFeedback'"></i>
                    <i v-else class="fa fa-caret-right"></i>
                </h2>
            </div>

            <director-feedback v-if="showPanel === 'allFeedback'">
            </director-feedback>

        </div>

    </section>
</template>
<script>

import _ from 'underscore';
import axios from 'axios';
import toastr from 'toastr';

import courses from '../services/courses';
import students from '../services/students';
import terms from '../services/terms';
import paths from '../services/paths';
import users from '../services/users';

import introVideos from './IntroVideos.vue';
import MyLessons from './reusable/my-lessons/MyLessons.vue';
import FinalProjects from './widgets/FinalProjects.vue';
import WatermarkedFiles from './widgets/WatermarkedFiles';
import SupervisorWeeklyContent from './widgets/SupervisorWeeklyContent';
import SupervisorJourney from './widgets/SupervisorJourney';
import DirectorIntroVideos from './widgets/DirectorIntroVideos';
import DirectorMeetings from './widgets/DirectorMeetings';
import DirectorFeedback from './widgets/DirectorFeedback';


export default {
    data() {
        return {
            courses: null,
            groups: null,
            allGroups: null,
            selectedGroup: null,
            selectedTerm: null,
            terms: null,
            academicPaths: null,
            focuses: null,
            supervisors: null,
            academicTerms: null,
            showPanel: null
        }
    },
    components: {
        'intro-videos': introVideos,
        'my-lessons': MyLessons,
        'final-projects': FinalProjects,
        'watermarked-files': WatermarkedFiles,
        'supervisor-weekly-content': SupervisorWeeklyContent,
        'supervisor-journey': SupervisorJourney,
        'director-intro-videos': DirectorIntroVideos,
        'director-meetings': DirectorMeetings,
        'director-feedback': DirectorFeedback
    },
    async mounted() {
        var self = this;
        await this.getTerms();         

        if (!localStorage.roles.includes('CampusDirector')) {
            this.getGroups();        
            await this.getPaths();
            await this.getFocuses();
            await self.getCourses();            
        }

        this.getSupervisors();
    },
    methods: {
        updateInstance(instance, termId) {
            courses.updateInstance(instance).then((response) =>{
                response.data.success === true ? toastr.success('Updated') : toastr.error('Error updating');

                const term = this.academicTerms.findIndex(i => i.id === termId);

                const key = Object.keys(this.academicTerms[term].courses)[0];

                this.academicTerms[term].courses[key] = this.academicTerms[term].courses[key].sort((a,b)=> {
                    return a.position - b.position;
                })
                
            });
        },
        getPathNameFromId(id) {
            if (id === 'undefined') return 'None';
            let path = this.academicPaths.find(function(p) { return p.id == id });
            if (path) return path.name;
            let focus = this.focuses.find(function(p) { return p.id == id });
            if (focus) return focus.name;
            return 'None';
        },
        getPathName(instance) {
            var self = this;

            let path;
            if (instance.paths) {
                let term = self.terms.find(function(t) { return t.id == instance.term });
                if (term.paths) {
                    path = instance.paths.find(function(p) {
                        return term.paths.includes(p.id);
                    });

                    if (path) return path.name;
                } else {
                    return "TERM MISSING PATH"
                }
            }

            return 'Foundation';
        },
        getTermName(termId) {
            let term = this.terms.find(function(t) { return t.id == termId });
            if (term) return term.name;
        },
        hasTerm(termId) {
            return this.terms.findIndex(function(t) { return t.id == termId }) > -1;
        },
        supervisorName(groupId) {
            const supervisor = this.supervisors.find(function(s) { if (s) return s.group.includes(groupId) })
            if (supervisor) return supervisor.firstName + ' ' + supervisor.lastName;
        },
        getSupervisors() {
            var self = this;
            users.getAll(this, 'Supervisor').then(function(response) {
                self.supervisors = response.data.map(function(s) { 
                    if (!s.group) s.group = [];
                });
            })
        },
        getFocuses() {
            var self = this;
            let url = 'https://cms.tttc.ca/wp-json/learning-paths/focus';
            return axios.get(url).then(function(response) {
                self.focuses = response.data.paths.map(function(f) {
                    return {
                        id: f.id,
                        name: f.name
                    }
                })
                return true;
            });
        },
        getPaths() {
            var self = this;
            return paths.getPaths(this).then(function(response) {
                self.academicPaths = response;
                return true;
            });
        },
        pathName(path) {
            if (!path) return;
            return this.academicPaths.find(function(p) { return p.id == path }).name;
        },
        openGroupStats() {
            const group = this.selectedGroup;
            this.$router.push({
                name: 'groupStatistics',
                params: { groupId: group.id, groupLabel: group.label, term: group.groupTerm.id }
            })
        },
        getTerms() {
            var self = this;
            return terms.get(this).then(function(response) {
                self.terms = response.data.terms;
                self.$forceUpdate();
                return true;
            });
        },
        termName(id) {
            let index = this.terms.findIndex(function(t) { return t.id == id });
            if (index > -1) return this.terms[index].name
        },
        getCourses() {
            var self = this;

            courses.getInstructorCourses().then(function(response) {

                self.courses = response.data;
                let academicTerms = [];
                response.data.forEach(function(c) {
                    let exists = academicTerms.find(function(t) { return t.id == c.term});
                    if (!exists) {
                        academicTerms.push({id: c.term, courses: []})
                    }
                })
                response.data.forEach(function(c) {
                    let term = academicTerms.find(function(t) { return t.id == c.term});
                    term.courses.push(c);
                });

                function startDate(termId) {
                    let term = self.terms.find(function(t) { return t.id == termId});
                    if (term) return term.startDate;
                }

                academicTerms.forEach(function(term, i) {
                    academicTerms[i].courses = academicTerms[i].courses.map(function(instance) {
                        if (instance.paths) {
                            let term = self.terms.find(function(t) { return t.id == instance.term });
                            if (term && term.paths) {
                                instance.path = instance.paths.find(function(p) {                                    
                                    return term.paths.includes(p.id);
                                });
                            }
                        }                    

                        return instance;
                    }).sort((a,b)=>{
                        return a.position - b.position;
                    });

                    academicTerms[i].courses = _.groupBy(academicTerms[i].courses, function(c) { 
                        if (c.focus) return c.focus.id;
                        if (c.path) return c.path.id;
                       
                    })
                });
                
                academicTerms = academicTerms.sort(function(a, b) {
                    return new Date(startDate(b.id)) - new Date(startDate(a.id));
                });

                self.academicTerms = academicTerms;

            });
        },
        getGroups() {
            var self = this;
            students.getGroups(this).then(function(response) {
                self.allGroups = response.data.groups
                    .map(function(g) { g.students = []; return g; })


                let supervisorGroups = localStorage.group.split(',').map(function(g) { return parseInt(g); });
                self.groups = response.data.groups
                    .filter(function(g) { return supervisorGroups.indexOf(g.id) > -1 })
                    .map(function(g) { g.students = []; return g; });

                self.getStudents();
            })
        },
        getStudents() {
            var self = this;
            students.get().then(function(response) {
                let myStudents = response.data;
                myStudents.forEach(function(student) {
                    if (!student) return;
                    if (!student.group) return;
                    if (!Array.isArray(student.group)) student.group = [student.group]
                    student.group.forEach(function(gr) {

                        let index = self.groups.findIndex(function(g) {
                            return gr == g.id;
                        });

                        if (index > -1) {
                            self.groups[index].students.push(student);
                        }

                        let directorGroup = self.allGroups.find(function(g) {
                            return gr == g.id;
                        });
                        if (!directorGroup) return;

                        let exists = directorGroup.students.find(function(s) { return s.id == student.id })
                        if (!exists) directorGroup.students.push(student);

                    });
                });

                let sortedGroups = self.allGroups
                    .filter(function(g) {
                        return g.students.length > 0 && g.groupTerm.type != 'foundation';
                    })
                    .sort(function(a, b) {
                        if (a.students[0].path === b.students[0].path) {
                            var x = new Date(a.groupTerm.startDate),
                                y = new Date(b.groupTerm.startDate);
                            return x < y ? -1 : x > y ? 1 : 0;
                        } else {
                            return a.students[0].path - b.students[0].path;
                        }
                    })

                let foundationGroups = self.allGroups.filter(function(a, index) {
                    return a.students.length > 0 && a.groupTerm.type == 'foundation'
                }).sort(function(a, b) {
                    return new Date(a.groupTerm.startDate) - new Date(b.groupTerm.startDate);
                });

                self.allGroups = foundationGroups.concat(sortedGroups);

                self.$forceUpdate();

                // myStudents.forEach(function(student) {
                //     console.log(JSON.stringify(student,null,2));
                //     let existing = self.groups.findIndex(function(g) { return g.id === student.group});
                //     if (existing === -1) {
                //         self.groups.push({
                //             id: student.group,
                //             label: student.groupLabel,
                //             students: []
                //         });
                //     }
                //     existing = self.groups.findIndex(function(g) { return g.id === student.group});
                //     self.groups[existing].students.push(student);

                // });

            });
        },

    },
    computed: {
        roles() {
            return JSON.parse(localStorage.roles);
        }
    }
}

</script>
<style lang="scss" scoped>
 h2 {
    cursor: pointer;
}

.instances {
    h3 {
        font-size: 2rem;
        margin-left: 8px;
        margin-top: 70px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content:space-between;
    }
    h4 {
        display:flex;
        align-items: center;
        justify-content:space-between;
        
    }

    img {
        max-width: 100px;
        margin-right: 1rem;
    }
}

.path {
    &>h4 {
        text-transform: uppercase;
    }
}

.flag {
    color: red;
    position: relative;
    top: -1rem;
}

.courses {
    ul {
        padding:0 2rem;
    }
    li {
        border: none;
    }

    li:nth-child(odd) {
        background: rgba(0, 0, 0, .2) !important;

    }

    img {
        max-width: 100px;
        max-height: 100px;
        margin-right: 20px;
    }
}

.description {
    padding: 20px 0 0 20px !important;
}

.groups {
    h4 {
        color: #33ccff;
    }
}

</style>



// WEBPACK FOOTER //
// Dashboard.vue?0ff64258